import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LoginVo } from "src/vo/loginVo";

const serverIp = process.env.REACT_APP_SERVER_IP;
const serverMsIp = process.env.REACT_APP_SERVER_MS_IP;
const msTenantId = process.env.REACT_APP_MS_TENANT_ID;

// 1-1. initial state 객체 생성
const initialState: LoginVo = {
  id: "",
  password: "",
  accessToken: "",
};

//M10075:::::Z1111111
export const loginAPI = createApi({
  reducerPath: "erpLoginAPI",
  baseQuery: fetchBaseQuery({ baseUrl: serverIp + "/" }),
  tagTypes: ["Post"],
  endpoints: (builder) => ({
    //  ========================= login API =========================
    erpLogin: builder.query<LoginVo, any>({
      query: (data) => ({
        url: `auth/login/erp`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
          mode: "no-cors", // cross domain 해결
        },
        body: data,
      }),
    }),
    msErpLogin: builder.query<LoginVo, any>({
      query: (token) => ({
        url: `auth/login/ms`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + token,
          Accept: "*/*, text/plain",
        },
      }),
    }),
    logout: builder.query<LoginVo, any>({
      query: (token) => ({
        url: `/auth/logout`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + token,
          Accept: "*/*, text/plain",
        },
      }),
    }),
    acTokenRefresh: builder.query<LoginVo, any>({
      query: (token) => ({
        url: `/auth/access`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + token,
          Accept: "*/*, text/plain",
        },
      }),
    }),
    reTokenRefresh: builder.query<LoginVo, any>({
      query: (token) => ({
        url: `/auth/refresh`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + token,
          Accept: "*/*, text/plain",
        },
      }),
    }),
  }),
});

export const msAPI = createApi({
  reducerPath: "msLoginAPI",
  baseQuery: fetchBaseQuery({ baseUrl: serverMsIp + "/" }),
  tagTypes: ["Post"],
  endpoints: (builder) => ({
    //  ========================= login API =========================
    msLogin: builder.query<LoginVo, any>({
      query: (data) => ({
        url: `${msTenantId}/oauth2/v2.0/authorize`,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "*/* ",
        },
        body: data,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
// export const { useAsTestQuery } = asListAPI;

export const { useErpLoginQuery, useMsErpLoginQuery, useLogoutQuery, useAcTokenRefreshQuery, useReTokenRefreshQuery } = loginAPI;
export const { useMsLoginQuery } = msAPI;
